<template>
    <el-dialog
        title="跟进记录详情"
        :visible.sync="followRecordDetailsVisible"
        width="520px"
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        class="custom-form-dialog custom-customer-detail-dialog"
    >
        <div v-loading="loading">
            <div class="dialog-title" v-if="formDetailData.user_name">
                <div class="dialog-title-left">
                    <img src="" alt="" />
                    <span>小虎</span>
                    <span>2024-09-20 15:30</span>
                </div>
                <span class="tag-status" v-if="formDetailData.type_name">线下沟通</span>
            </div>
            <p class="tip-txt">
                {{ formDetailData.content && formDetailData.content.value }}
            </p>
            <CustomFormDetailPc
                :field_list="formInfoList"
                v-if="dataLoaded"
                :form_detail="formDetailData"
                :pk_id="Number(followRecordId)"
                :is_custom_col_span="true"
            />
        </div>
    </el-dialog>
</template>
<script>
import { getFormFields, customerPrivateFollowUpDetail } from "@/api";
import CustomFormDetailPc from "@/components/pComponents/CustomFormDetailPc";
export default {
    name: "FollowRecordDetails",
    components: { CustomFormDetailPc },
    props: {
        followRecordDetailsVisible: {
            type: Boolean,
            default: false,
        },
        followRecordId: "",
    },
    data() {
        return {
            loading: true,
            formInfoList: [],
            formDetailData: {},
            dataLoaded: false
        };
    },
    mounted() {
        this._getFromFields()
    },
    methods: {
        _getFromFields() {
            this.loading = true;
            getFormFields({
                field_form: "customer_follow_ups",
            }).then((res) => {
                if (res.code === 200) {
                    this.formInfoList = res.data.filter(item=> item.field_key !== 'content').map(item=> ({...item,col_span: 24}));
                    customerPrivateFollowUpDetail(this.followRecordId).then((res) => {
                        if (res.code === 200) {
                            this.formDetailData = res.data;
                            this.loading = false;
                            this.dataLoaded = true
                        }
                        this.loading = false;
                    });
                }
            });
        },
        handleDialogClose() {
            this.$emit("update:followRecordDetailsVisible", false);
        },
    },
};
</script>
<style lang="scss">
.custom-customer-detail-dialog {
    .el-dialog__body {
        padding: 24px 16px;
        min-height: 400px;
        max-height: 492px;
        overflow-y: scroll;
        & > div {
            height: 100%;
        }
    }

    .dialog-title {
        display: flex;
        justify-content: space-between;
        margin-bottom: 20px;

        .dialog-title-left {
            display: flex;
            gap: 8px;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(102, 102, 102, 1);

            img {
                width: 22px;
                height: 22px;
                border-radius: 50%;
            }

            span:nth-child(2) {
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0px;
                line-height: 22px;
                color: rgba(51, 51, 51, 1);
            }
        }

        .tag-status {
            padding: 0 8px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            background: rgba(0, 186, 173, 0.1);
            color: rgba(0, 186, 173, 1);
        }
    }

    .tip-txt {
        padding: 8px 12px;
        border-radius: 4px;
        background: rgba(237, 240, 244, 1);
        font-size: 14px;
        font-weight: 400;
        letter-spacing: 0px;
        line-height: 22px;
        color: rgba(102, 102, 102, 1);
        margin-bottom: 12px;
    }

    .form-details {
        .el-col {
            margin-top: 12px;
            display: flex;
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            line-height: 22px;
            color: rgba(51, 51, 51, 1);

            span:nth-child(1) {
                flex-shrink: 0;
                color: rgba(153, 153, 153, 1);
            }
        }

        .download-box {
            width: 100%;
            height: 22px;
            padding: 0 8px;
            border-radius: 2px;
            background: rgba(249, 249, 249, 1);
            border: 1px solid rgba(217, 217, 217, 1);
            display: flex;
            justify-content: space-between;
            align-items: center;
            .icon-daochu {
                font-size: 12px;
            }
        }
    }
}
</style>
